"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('services/fourFiveService',["require", "exports", "controllers/fourFiveController"], function (require, exports, fourFiveController) {
    "use strict";

    var FourFiveService = function () {
        function FourFiveService() {
            _classCallCheck(this, FourFiveService);
        }

        _createClass(FourFiveService, [{
            key: "search",
            value: function search(searchString) {
                return fourFiveController.search(searchString);
            }
        }, {
            key: "user",
            value: function user(userId) {
                return fourFiveController.user(userId);
            }
        }, {
            key: "updateUserType",
            value: function updateUserType(userId, currentTypeId) {
                return fourFiveController.updateUserType(userId, currentTypeId);
            }
        }, {
            key: "policy",
            value: function policy(userId) {
                return fourFiveController.policy(userId);
            }
        }, {
            key: "tests",
            value: function tests(userId) {
                return fourFiveController.tests(userId);
            }
        }, {
            key: "appDetails",
            value: function appDetails(userId) {
                return fourFiveController.appDetails(userId);
            }
        }, {
            key: "activities",
            value: function activities(userId) {
                return fourFiveController.activities(userId);
            }
        }, {
            key: "communications",
            value: function communications(userId) {
                return fourFiveController.communications(userId);
            }
        }, {
            key: "score",
            value: function score(userId, timeFrame) {
                return fourFiveController.score(userId, timeFrame);
            }
        }, {
            key: "ranking",
            value: function ranking(userId, timeFrame) {
                return fourFiveController.ranking(userId, timeFrame);
            }
        }, {
            key: "eligibilityDetails",
            value: function eligibilityDetails(userId) {
                return fourFiveController.eligibilityDetails(userId);
            }
        }, {
            key: "dataDrop",
            value: function dataDrop(userId) {
                return fourFiveController.dataDrop(userId);
            }
        }, {
            key: "callbacks",
            value: function callbacks(userId) {
                return fourFiveController.callbacks(userId);
            }
        }, {
            key: "userAggData",
            value: function userAggData(userId) {
                return fourFiveController.userAggData(userId);
            }
        }, {
            key: "getLastUserImport",
            value: function getLastUserImport() {
                return fourFiveController.getLastUserImport();
            }
        }, {
            key: "getPreviousUserImports",
            value: function getPreviousUserImports(offset, count) {
                return fourFiveController.getPreviousUserImports(offset, count);
            }
        }, {
            key: "getPreviousUserImport",
            value: function getPreviousUserImport(fileName) {
                return fourFiveController.getPreviousUserImport(fileName);
            }
        }, {
            key: "downloadUserImportFile",
            value: function downloadUserImportFile(fileName) {
                return fourFiveController.downloadUserImportFile(fileName);
            }
        }, {
            key: "validateUserImport",
            value: function validateUserImport(csvFile) {
                return fourFiveController.validateUserImport(csvFile);
            }
        }, {
            key: "uploadUserImport",
            value: function uploadUserImport(csvFile) {
                return fourFiveController.uploadUserImport(csvFile);
            }
        }, {
            key: "getRankings",
            value: function getRankings(timeFrame, filter, search, includeTestUsers) {
                return fourFiveController.getRankings({ timeFrame: timeFrame, filter: filter, search: search, includeTestUsers: includeTestUsers });
            }
        }, {
            key: "getEligibility",
            value: function getEligibility() {
                return fourFiveController.getEligibility();
            }
        }, {
            key: "getUserScores",
            value: function getUserScores(userId, timeFrame, filter) {
                return fourFiveController.getUserScores({ timeFrame: timeFrame, filter: filter, userId: userId });
            }
        }, {
            key: "getScoreDetails",
            value: function getScoreDetails(userId, type, resourceId, scoreDate) {
                return fourFiveController.getScoreDetails({ userId: userId, type: type, resourceId: resourceId, scoreDate: scoreDate });
            }
        }, {
            key: "toggleScoring",
            value: function toggleScoring(userId) {
                return fourFiveController.toggleScoring({ userId: userId });
            }
        }]);

        return FourFiveService;
    }();

    return new FourFiveService();
});
//# sourceMappingURL=fourFiveService.js.map;
